import React, { useEffect, useRef, useImperativeHandle, forwardRef, useState } from 'react';
import { OtpContainer, InputContainer, InputMessage } from './components';
import { OtpInputDefaultProps, OtpInputPropTypes } from './types/OtpInput.prop-types';
import { useOtpReducer } from './OtpHook';
export const OtpInput = forwardRef((props, ref) => {
    const { disabled, onComplete, otpLength = 6, hintMessage, errorMessage, handleChange, controlledMode, shouldAutoFocus, denyInvalidFilled, isInvalid: invalid, } = props;
    const containerRef = useRef();
    const [isInvalid, setInvalid] = useState(invalid);
    const optInputs = Array(otpLength).fill(otpLength);
    const [state, dispatch] = useOtpReducer();
    // Manage Deny invalid state when otp filled
    useEffect(() => {
        if (denyInvalidFilled && state.values.length && invalid) {
            setInvalid(false);
        }
        else {
            setInvalid(invalid);
        }
    }, [state.values, invalid]);
    // Focus on first input when component is mounted
    useEffect(() => {
        shouldAutoFocus && focusInput(0);
    }, []);
    // Manage callback effects
    useEffect(() => {
        const finalValue = [...state.values].join('');
        if (finalValue.length === otpLength)
            onComplete && onComplete(finalValue);
        handleChange && handleChange(finalValue);
    }, [state.values]);
    const blurInput = (refIndex) => containerRef.current && containerRef.current.children[refIndex].blur();
    const focusInput = (refIndex) => containerRef.current && containerRef.current.children[refIndex].focus();
    const onChange = (index) => (event) => {
        let value = typeof event === 'string'
            ? event
            : event.target.value;
        const validValue = parseInt(value);
        if ((!!validValue || validValue === 0)) {
            if (value.length === 1) {
                dispatch({ type: 'ADD_VALUE', payload: { value, index } });
            }
            if (value.length === 6) {
                const copiedValue = Array.from(String(value));
                dispatch({ type: 'ADD_PASTE_VALUE', payload: { copiedValue, index } });
            }
            if (index < otpLength - 1) {
                focusInput(index + 1);
            }
            else {
                blurInput(index);
            }
        }
    };
    const removeOtpValue = (index) => ({ key }) => {
        if (key === 'Backspace') {
            removeValueIfExist(index);
            if (!state.values[index] && index > 0)
                containerRef.current.children[index - 1].focus();
        }
    };
    const onContainerClick = () => {
        if (!controlledMode)
            return;
        const currentInput = state.values.length >= otpLength
            ? otpLength - 1
            : state.values.length;
        removeValueIfExist(currentInput);
        containerRef.current.children[currentInput].focus();
    };
    const removeValueIfExist = (index) => {
        if (state.values[index]) {
            if (controlledMode) {
                dispatch({ type: 'REMOVE_VALUE_BY_INDEX', payload: { index } });
            }
            else {
                dispatch({ type: 'REPLACE_VALUE_BY_INDEX', payload: { index } });
            }
        }
    };
    const updateValue = (index) => ({ key }) => {
        if (state.values[index]) {
            onChange(index)(key);
        }
    };
    const resetValues = () => dispatch({ type: 'RESET_VALUES', payload: { index: 0 } });
    useImperativeHandle(ref, () => ({ resetValues }));
    return (React.createElement(React.Fragment, null,
        React.createElement(OtpContainer, { ref: containerRef, onClick: onContainerClick }, optInputs.map((_, index) => (React.createElement(InputContainer, { index: index, inputMode: 'decimal', disabled: disabled, key: `otp-${index}`, isInvalid: isInvalid, onChange: onChange(index), controlledMode: controlledMode, onKeyPress: updateValue(index), onKeyDown: removeOtpValue(index), value: state.values[index] || '', id: `otp-input-${index}` })))),
        isInvalid
            ? React.createElement(InputMessage, { isInvalid: isInvalid }, errorMessage)
            : React.createElement(InputMessage, null, hintMessage)));
});
OtpInput.defaultProps = OtpInputDefaultProps;
OtpInput.propTypes = OtpInputPropTypes;
//# sourceMappingURL=OtpInput.js.map